import config from "../config";
import { fetchJsonDesktopSafe } from "./desktopFetch";

/**
 * Load server-supported connector lookback limits and presets.
 *
 * @returns {Promise<Object>} Connector lookback configuration.
 * @example
 * await getLookbackOptions();
 * // { quick_presets: [1, 3, 7, 14], min_days: 1 }
 */
export const getLookbackOptions = async () =>
  fetchJsonDesktopSafe(`${config.BACKEND_URL}/connectors/lookback-options`);
